var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mdc-tab-indicator vt-tab-indicator",class:_vm.cssClass},[_c('span',{staticClass:"mdc-tab-indicator__content mdc-tab-indicator__content--underline",style:(_vm.contentStyle)})])}
var staticRenderFns = []

export { render, staticRenderFns }